import { IGetImplantableDeviceResponse } from "../../services/patient.service";

export class ImplantableDevice implements IGetImplantableDeviceResponse {
    public Id?: string;
    public Udi: string = "";
    public Name: string = "";
    public Identifier: string = "";
    public Description: string = "";
    public VersionModelNumber: string = "";
    public CompanyName: string = "";
    public LotBatchNumber: string = "";
    public BrandName: string = "";
    public SerialNumber: string = "";
    public ExpirationDate: string = "";
    public ManufacturingDate: string = "";
    public SafetyInformation: string = "";
    public IssuingAgency: string = "";
    public HasNaturalRubber: boolean = false;
    public IsHumanOrIssueProduct: boolean = false;
    public DateOfImplant: string = "";
    public DeviceStatus: number = null;

    public constructor(data?: IGetImplantableDeviceResponse) {
        if (!!data) {
            Object.assign(this, data);
        }
    }
}
